import { render, staticRenderFns } from "./AuthorDetail.vue?vue&type=template&id=c2398484&"
import script from "./AuthorDetail.vue?vue&type=script&lang=js&"
export * from "./AuthorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports